import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}function n(e,t,n){let r=e;for(let e of t){if(r==null)break;r=r[e]}return r??n}export{t as pathOr};
//# sourceMappingURL=pathOr-DOtWhQf1.js.map